import { ApeironBlueButton, NextImage, RoninSVG } from '@apeiron/temp'
import { styled } from '@mui/material'
import { useTranslation } from 'react-i18next'

const Button = styled(ApeironBlueButton)`
  --background-color: #1473e9;
  max-height: 50px;
  border-radius: 4px;
  color: white;
  flex: 1;
  font-size: 16px;
  gap: 6px;
  height: 50px;
  margin-left: auto;
  width: 100%;
  :hover {
    filter: brightness(0.9);
  }
`

const RoninWalletIcon = styled(NextImage)`
  filter: grayscale(100%) brightness(3);
  width: 24px;
  height: 24px;
`

const RoninWalletButton = ({ onClick }: Props) => {
  const { t } = useTranslation()

  return (
    <Button onClick={onClick}>
      <RoninWalletIcon src={RoninSVG} />
      {t('login.general.button.ronin')}
    </Button>
  )
}

type Props = {
  onClick: () => void
}

export default RoninWalletButton
